export default __webpack_public_path__ + "923e3d023fc9ecf50bddf3a8db910c64.svg";